import axios from 'utils/axios';

export const getClientBalance = async () => {
  return await (await axios.get<{ total: number }>('/api/client/totalbalance')).data.total;
};
